// src/contexts/BillerLayoutContext.js
//
// Layout de navegación del dashboard de la empresa (doc/47 §11):
//   layout-1 → barra de módulos horizontal arriba (default, lo de siempre)
//   layout-2 → barra lateral izquierda vertical, con los sub-módulos anidados
//
// MainLayout es el dueño de la barra lateral (posición, ancho, colapso, apertura
// en mobile) porque el contenido y el navbar se corren según su ancho. Pero la
// empresa activa y su menú los conoce BillerDashboard. Este contexto los une:
// BillerDashboard publica el layout de la empresa con setBillerLayout y dibuja su
// menú por portal en railElement.

import { createContext, useContext } from 'react';

export const BILLER_LAYOUTS = ['layout-1', 'layout-2'];
export const DEFAULT_BILLER_LAYOUT = 'layout-1';

// Rótulos del desplegable "Layout" del alta y la edición de empresa.
export const BILLER_LAYOUT_OPTIONS = [
  { value: 'layout-1', label: 'Layout 1 — barra superior' },
  { value: 'layout-2', label: 'Layout 2 — menú lateral' },
];

export const BillerLayoutContext = createContext({
  billerLayout: null,
  setBillerLayout: () => {},
  railElement: null,
  railActionsElement: null,
  railCollapsed: false,
});

export const useBillerLayout = () => useContext(BillerLayoutContext);
